import React from 'react';
import {
  components as ReactSelectComponents,
  GroupBase,
  SingleValueProps,
} from 'react-select';
import styled from 'styled-components';
import { theme } from '../../../../../styles/theme';

const SelectedText = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.mainBlue};
`;

const SingleValue = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  ...singleValueProps
}: SingleValueProps<Option, IsMulti, Group>) => {
  return (
    <ReactSelectComponents.SingleValue {...singleValueProps}>
      <SelectedText>{children}</SelectedText>
    </ReactSelectComponents.SingleValue>
  );
};

export default SingleValue;
